import { render, staticRenderFns } from "./TeamsHistoricalData.vue?vue&type=template&id=704d7f32&"
import script from "./TeamsHistoricalData.vue?vue&type=script&lang=js&"
export * from "./TeamsHistoricalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports